import React, { createContext, useContext, useState, useCallback } from 'react';
import AlertModal from '../components/AlertModal';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
    const [alertState, setAlertState] = useState({
        isOpen: false,
        title: '',
        message: '',
        type: 'info',
        confirmText: '확인',
        onClose: null
    });

    const showAlert = useCallback(({ title, message, type = 'info', confirmText = '확인' }) => {
        return new Promise((resolve) => {
            setAlertState({
                isOpen: true,
                title,
                message,
                type,
                confirmText,
                onClose: () => {
                    setAlertState(prev => ({ ...prev, isOpen: false }));
                    resolve();
                }
            });
        });
    }, []);

    // 편의 메서드들
    const success = useCallback((message, title) =>
        showAlert({ message, title, type: 'success' }), [showAlert]);

    const error = useCallback((message, title) =>
        showAlert({ message, title, type: 'error' }), [showAlert]);

    const warning = useCallback((message, title) =>
        showAlert({ message, title, type: 'warning' }), [showAlert]);

    const info = useCallback((message, title) =>
        showAlert({ message, title, type: 'info' }), [showAlert]);

    const value = {
        showAlert,
        success,
        error,
        warning,
        info
    };

    return (
        <AlertContext.Provider value={value}>
            {children}
            <AlertModal
                isOpen={alertState.isOpen}
                title={alertState.title}
                message={alertState.message}
                type={alertState.type}
                confirmText={alertState.confirmText}
                onClose={alertState.onClose}
            />
        </AlertContext.Provider>
    );
}

export function useAlert() {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
}

export default AlertContext;
